module.exports = __webpack_public_path__ + "static/media/300_2.0c886456.jpg";